
import Dislike from "../../../assets/outline/Dislike.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DislikeIcon({ className, dataTestid = "DislikeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Dislike data-testid={dataTestid} className={classes} {...rest} />
  );
}
